module.exports = __webpack_public_path__ + "static/img/y45.e55cb12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y45.jpg
// module id = Mf3f
// module chunks = 1